import React from 'react';
import {Link} from 'react-router-dom';
import Loader from './Loader';
import AppHeader from './AppHeader';
import BottomMenu from './BottomMenu';
import SidebarPanel from './SidebarPanel';

import $ from "jquery";

class SearchItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOCATION: this.props.location.pathname,
            LOADING: true, 
            CATEGORY: '',
            BRAND:'',
            PRODUCTS: [],
            category_id: props.match.params.id,
            CATEGORYNAME: '',
            CUSTOMER_DET: '',
            page: 1,
            displayLoadMore: 'N',
            orderby: '',
            FAVOURITES: 0,
            customerid: localStorage.getItem('userData'),
            search_text: props.match.params.search_text,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    GetItemSearchResult(search_text) {

        this.setState({ search_text:search_text });

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ mode: 'SEARCH_ITEMS_LIST', search_term:search_text, orderby:this.state.orderby, customer: this.state.customerid})
        };

        fetch(global.config.bURL+"item_list.php", requestOptions)
            .then(function (response) {
                return response.json();
            })
            .then((result)=> {

            //console.log(result);

            let CATEGORY = result.CATEGORY;
            let BRAND = result.BRAND;
            let ITEMS = [];
            ITEMS = result.ITEMS;
            let FAVOURITES = result.FAVOURITES;
            var CUSTOMER_DET = 'Retail~~**~~Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
                
            localStorage.setItem('nkis_favourites', FAVOURITES);
                
            this.setState({ 
                PRODUCTS:ITEMS,
                page: result.page,
                displayLoadMore: result.LOADMORE,
                FAVOURITES: FAVOURITES,
                CATEGORY: CATEGORY,
                BRAND: BRAND,
                CUSTOMER_DET: CUSTOMER_DET,
                LOADING: false, 
            });
        });
    }

    fetchSecond(page) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ mode: 'SEARCH_ITEMS_LIST', search_term:this.state.search_text, orderby:this.state.orderby, page:page, customer: this.state.customerid})
        };

        fetch(global.config.bURL+"item_list.php", requestOptions)
            .then(function (response) {
                return response.json();
            })
            .then((result)=> {

            let CATEGORY = result.CATEGORY;
            let BRAND = result.BRAND;
            let ITEMS = result.ITEMS;
            let FAVOURITES = result.FAVOURITES;
            var CUSTOMER_DET = 'Retail~~**~~Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;

            this.setState({ 
                PRODUCTS:this.state.PRODUCTS.concat(result.ITEMS),
                page: result.page,
                displayLoadMore: result.LOADMORE,
                FAVOURITES: FAVOURITES,
                CATEGORY: CATEGORY,
                BRAND: BRAND,
                CUSTOMER_DET: CUSTOMER_DET,
                LOADING: false, 
            });
        });
    }

    handleSubmit(event) {
		event.preventDefault();

        var search_text = event.target.elements.search.value;
        this.GetItemSearchResult(search_text);

		//event.target.elements.search.value = '';
	}

    handleSearchKeyUp() {
        var search_text = $('#search_text').val();
        if(search_text.length>2)
            this.GetItemSearchResult(search_text);
		//event.target.elements.search.value = '';
	}
    
    componentDidMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount===true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
        }

        var search_text = this.state.search_text;
        if(search_text===undefined || search_text==='undefined')
            search_text = '';
        
        this.GetItemSearchResult();
    }

    componentWillReceiveProps(nextProps) {
        window.location.reload();
    }

    loadMore = () => {
        this.fetchSecond(this.state.page);
    };
  
    render() { 
    	let AppHeaderClass = 'nkis-header appHeader no-shadow';
    	let AppHeaderLeft = 'showLINK';
    	let AppHeaderLeftLink = '/home';
    	let AppHeaderTitle = 'Search';
    	let AppHeaderIMAGE = '';
    	let AppHeaderRight = 'showLINK';
    	let AppHeaderRightLink = '';

        let items = this.state.PRODUCTS.map((post, i)=>{

            let outofstock = '';
            if(post.STOCK==='N')
                outofstock = ' outofstock';

            return (
                <div className="col-6" key={post.ID}>
                    <Link to={`/item/${post.ID}`} >
                        <div className="card">
                            <div className="cat-img-cover">
                                <div className={`cat-img${outofstock}`}>
                                    <img src={post.IMAGE} className="card-img-top imaged w-100" alt={post.ALT_TAG} />
                                </div>
                                {post.DISCOUNT>0 && 
                                    <div className="chip chip-info chip-offer bg-purple ml-05 mb-05">
                                        <span className="chip-label font-16">{post.DISCOUNT}%</span>
                                        <span className="font-11 text-upper">Off</span>
                                    </div>
                                }
                                {post.STOCK==='F' && 
                                    <div className="chip chip-info few-left bg-red ml-0 mb-05">
                                        <span className="chip-label font-10 text-upper">Few Left</span>
                                    </div>
                                }
                                {post.STOCK==='N' && 
                                    <div className="chip chip-info few-left bg-grey ml-0 mb-05">
                                        <span className="chip-label font-10 text-upper">Out of Stock</span>
                                    </div>
                                }
                            </div>
                            <div className="card-body pt-05 pb-0 pr-0 pl-0">
                                <p className="card-text text-grey4 font-16 ft-wt-400 mb-0 text-upper text-left">{post.NAME}</p>
                                <div className="cat-price pt-05">
                                    <p className="mb-0 final-price text-dblue font-15 ft-wt-400 text-upper pr-05"> &#8377; {post.PRICE} </p>
                                    {post.MRP>0 && post.MRP>post.PRICE && <p className="mb-0 text-dgrey orginal-price"> <small>&#8377; {post.MRP}</small> </p>}
                                    {post.IS_FAVOURITE==='N' && <ion-icon className="liked-cat unlike-filled" name="heart"></ion-icon>}
                                    {post.IS_FAVOURITE==='Y' && <ion-icon className="liked-cat like-filled" name="heart"></ion-icon>}
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            );
        });

        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderIMAGE={AppHeaderIMAGE} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} />
                <div id="appCapsule">
                    <div className="category-listing login-form mt-1">
                        <div className="wide-block pt-2 pb-2 bg-transparent search-area">
                            <form className="search-form" onSubmit={this.handleSubmit}>
                                <div className="form-group searchbox">
                                    <input type="text" className="form-control" id="search_text" name="search" placeholder="Search..." onKeyDown={this.onKeyDown} onKeyUp={()=>{this.handleSearchKeyUp()}} minLength="3" />
                                    <i className="input-icon">
                                        <ion-icon name="search-outline"></ion-icon>
                                    </i>
                                </div>
                            </form>
                        </div>
                        {items.length>0 &&
                            <div className="section mt-0 mb-0 pt-0 pr-0 pl-0">
                                <div className="row mr-0 ml-0">
                                    {items}
                                </div>
                                {this.state.displayLoadMore==='Y' && <p>
                                    <button type="button" style={{'height': '31px'}} onClick={() => this.loadMore()} className="btn newshadowed text-dgrey font-size-11 square btn-danger btn-llg btn-block goBack">Load More</button>
                                </p>}
                            </div>
                        }
                        {items.length===0 &&
                            <div className="section pt-6" style={{textAlign: 'center'}}>
                                <img src="/assets/img/no-records.png" alt="empty-cart" className="form-image imaged w200" />
                            </div>
                        }
                    </div>
                </div>
                <BottomMenu LOCATION={this.state.LOCATION} />
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
      
export default SearchItem;